import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/author/_author/project/_project')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.projects' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
